/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export class PropulsionScenario {
  id: number;
  portType: string;
  propulsionScenarioName: string;
  propulsionScenarioAssumption: string;
  forecastOrganization: string;
  isEditLocked: boolean;
  isDeleteLocked: boolean;
  createdById: string;
  timeStamp: string;
  budgetYear: number;
  createdBy: string;
  isHidden: boolean;
}
